import { DateRange } from 'src/app/shared/models/dateRange';

export class PersonCertification {
  public id: string;
  public activeRange: DateRange;
  public group: string;
  public name: string;
  public number: string;
  public shortName: string;
  public externalId: string;
  public sourceType: string;
  public url: string;
  public createdOn: Date;

  constructor(personCertification: any = undefined) {
    if (personCertification) {
      this.setProperties(personCertification);
    }
  }

  get isActive(): boolean {
    // A blank model from the add form has no range, same as a certification with no
    // dates: active.
    return this.activeRange ? this.activeRange.todayIsWithinDateRange() : true;
  }

  private setProperties(personCertification: any) {
    this.id = personCertification.id;
    this.activeRange = new DateRange(
      personCertification.activeDate,
      personCertification.expirationDate
    );
    this.group = personCertification.group;
    this.name = personCertification.name;
    this.number = personCertification.number;
    this.shortName = personCertification.shortName;
    this.externalId = personCertification.externalId;
    this.sourceType = personCertification.sourceType;
    this.url = personCertification.url;
    this.createdOn = personCertification.createdOn;
  }
}
